enum CheckType {
  MinAge = 'min_age',
  SupervisorApproval = 'supervisor_approval',
}

export default CheckType;
